import { RuntimeEnvironments } from "@tsp/env";

export const createEnvReducer = (initialState: RuntimeEnvironments) => {
  return (state = initialState) => state;
};
